module.exports = __webpack_public_path__ + "static/media/lineicons-original.73ca9c2c.svg";